import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';

import { INewbuildingPromo } from '../../types/newbuildingPromo';
import { ItemsCarousel } from '../ItemsCarousel';
import { BlackFridayPromo } from './components/BlackFridayPromo';
import { PromoAttributes } from './components/PromoAttributes';
import { PromoItem } from './components/PromoItem';
import { PromoLink } from './components/PromoLink';
import * as styles from './NewbuildingPromoBlock.css';

export interface INewbuildingPromoBlockProps {
  // TODO: Удалить эти свойства в задаче CD-183467.
  isBlackFridayActive: boolean;
  blackFridayUrl: string;
  onBlackFridayPromoShow: () => void;
  onBlackFridayPromoClick: () => void;

  onPromoClick(promo: INewbuildingPromo, index: number): void;
  onPromoLinkClick?(): void;
  promos: INewbuildingPromo[];
  promosUrl: string;
}

export const NewbuildingPromoBlock: React.FC<INewbuildingPromoBlockProps> = ({
  isBlackFridayActive,
  blackFridayUrl,
  onBlackFridayPromoShow,
  onBlackFridayPromoClick,
  onPromoClick,
  onPromoLinkClick,
  promos,
  promosUrl,
}) => {
  return (
    <section className={styles['container']} data-testid="NewbuildingPromoBlock">
      <div className="cg-container-fluid-xs">
        <h2 className={styles['title']}>Акции и скидки на новостройки</h2>
        <ItemsCarousel scrollVisible>
          {promos.map((promo, idx) => {
            // TODO: Удалить условие в задаче CD-183467.
            if (isBlackFridayActive && promo.providerPromoId === -1) {
              return (
                <ActionAfterViewObserver key={promo.uniquePromoId} callback={onBlackFridayPromoShow} triggerOnce>
                  <BlackFridayPromo url={blackFridayUrl} onClick={onBlackFridayPromoClick} />
                </ActionAfterViewObserver>
              );
            }

            return (
              <PromoItem
                key={promo.uniquePromoId}
                attributes={<PromoAttributes promo={promo} />}
                activeDateTo={promo.activeDateToText}
                name={promo.promoName}
                providerLogo={promo.providerLogo}
                providerName={promo.providerName}
                onClick={() => onPromoClick(promo, idx)}
              />
            );
          })}
          <PromoLink url={promosUrl} onClick={onPromoLinkClick} />
        </ItemsCarousel>
      </div>
    </section>
  );
};
